"use strict";

document.addEventListener("DOMContentLoaded", function () {
  let adpPopup = {};

  (function () {
    let $this;

    adpPopup = {
      sPrevious: window.scrollY,
      sDirection: "down",
      currentPopup: null,
      previousActiveElement: null,

      init: function () {
        $this = adpPopup;
        $this.popupInit();
        $this.events();
      },

      events: function () {
        document.addEventListener("click", function (e) {
          const popupCloseButton = e.target.closest(".popup-close");
          if (popupCloseButton) {
            e.preventDefault();
            $this.closePopup(popupCloseButton);
            return;
          }

          const ageVerificationCloseButton = e.target.closest(
            ".age-verification__popup-close"
          );
          if (ageVerificationCloseButton) {
            e.preventDefault();
            $this.agePopup(ageVerificationCloseButton);
            $this.closePopup(ageVerificationCloseButton);
            return;
          }

          const acceptButton = e.target.closest(".popup-accept");
          if (acceptButton) {
            $this.acceptPopup(acceptButton);
            $this.closePopup(acceptButton);
          }

          const declinedButton = e.target.closest(".age-verification__button-no");
          if (declinedButton) {
            $this.ageDeclined();
          }
          if (e.target.matches(".popup-overlay")) {
            document
              .querySelectorAll('.popup-open[data-overlay-close="true"]')
              .forEach((popup) => {
                $this.closePopup(popup);
              });
          }
        });

        document.addEventListener("keydown", function (e) {
          if (e.key !== "Tab") return;
          const popup = $this.currentPopup;
          if (!popup || !popup.classList.contains("popup-open")) return;

          const focusable = $this.getFocusableElements(popup);
          if (focusable.length === 0) {
            e.preventDefault();
            popup.focus();
            return;
          }

          const first = focusable[0];
          const last = focusable[focusable.length - 1];
          const active = document.activeElement;
          const goingBackward = e.shiftKey;

          if (!goingBackward && active === last) {
            e.preventDefault();
            first.focus();
          } else if (goingBackward && active === first) {
            e.preventDefault();
            last.focus();
          }
        });

        document.addEventListener("keyup", function (e) {
          if (e.key === "Escape") {
            document
              .querySelectorAll('.popup-open[data-esc-close="true"]')
              .forEach((popup) => {
                $this.closePopup(popup);
              });
          }
          if (e.key === "F4") {
            document
              .querySelectorAll('.popup-open[data-f4-close="true"]')
              .forEach((popup) => {
                $this.closePopup(popup);
              });
          }
        });
      },

      popupInit: function () {
        document.addEventListener("scroll", function () {
          const scrollCurrent = window.scrollY;
          $this.sDirection = scrollCurrent > $this.sPrevious ? "down" : "up";
          $this.sPrevious = scrollCurrent;
        });

        document.querySelectorAll(".popup").forEach((popup) => {
          const triggerType = popup.dataset.openTrigger;

          if (triggerType === "manual") {
            const selector = popup.dataset.openManualSelector;
            if (selector) {
              document.querySelectorAll(selector).forEach((el) => {
                el.classList.add("popup-trigger");
                el.addEventListener("click", function (e) {
                  const interactiveTarget = e.target.closest("a, button");
                  if (!interactiveTarget) {
                    e.preventDefault();
                  }
                  popup.classList.remove("popup-already-opened");
                  $this.openPopup(popup);
                });
              });
            }
          }

          if (
            !$this.isAllowPopup(popup) &&
            !popup.classList.contains("age-verification")
          ) {
            return;
          }

          $this.openTriggerPopup(popup);
        });
      },

      openTriggerPopup: function (popup) {
        const trigger = popup.dataset.openTrigger;

        if (trigger === "none") {
          const isEditor =
            typeof window !== "undefined" &&
            window.Shopify &&
            window.Shopify.designMode;

          if (popup.classList.contains("age-verification") && isEditor) {
            $this.openPopup(popup);
          } else {
            const ageVerification = $this.getStorage(
              "popup-age-" + (popup.dataset.id || 0)
            );
            if (!ageVerification) $this.openPopup(popup);
          }
        }

        if (trigger === "delay") {
          setTimeout(
            () => $this.openPopup(popup),
            popup.dataset.openDelayNumber * 1000
          );
        }

        if (trigger === "exit") {
          let showExit = true;
          document.addEventListener("mousemove", function (e) {
            const scroll =
              window.pageYOffset || document.documentElement.scrollTop;
            if (e.pageY - scroll < 7 && showExit) {
              $this.openPopup(popup);
              showExit = false;
            }
          });
        }

        if (trigger === "scroll") {
          const type = popup.dataset.openScrollType;
          const position = popup.dataset.openScrollPosition;
          document.addEventListener("scroll", function () {
            if (type === "px" && window.scrollY >= position) {
              $this.openPopup(popup);
            }
            if (type === "%" && $this.getScrollPercent() >= position) {
              $this.openPopup(popup);
            }
          });
        }

        if (trigger === "accept") {
          const accepted = $this.getStorage(
            "popup-accept-" + (popup.dataset.id || 0)
          );
          if (!accepted) $this.openPopup(popup);
        }
      },

      closeTriggerPopup: function (popup) {
        const trigger = popup.dataset.closeTrigger;

        if (trigger === "delay") {
          setTimeout(
            () => $this.closePopup(popup),
            popup.dataset.closeDelayNumber * 1000
          );
        }

        if (trigger === "scroll") {
          const type = popup.dataset.closeScrollType;
          const pos = parseFloat(popup.dataset.closeScrollPosition);
          const initPx = parseFloat(popup.dataset.initScrollPx);
          const initPercent = parseFloat(popup.dataset.initScrollPercent);

          document.addEventListener("scroll", function () {
            if (type === "px") {
              if ($this.sDirection === "up" && window.scrollY < initPx - pos)
                $this.closePopup(popup);
              if ($this.sDirection === "down" && window.scrollY >= initPx + pos)
                $this.closePopup(popup);
            }
            if (type === "%") {
              if (
                $this.sDirection === "up" &&
                $this.getScrollPercent() < initPercent - pos
              )
                $this.closePopup(popup);
              if (
                $this.sDirection === "down" &&
                $this.getScrollPercent() >= initPercent + pos
              )
                $this.closePopup(popup);
            }
          });
        }
      },

      openPopup: function (popup) {
        if (
          popup.classList.contains("popup-open") ||
          popup.classList.contains("popup-already-opened")
        ) {
          return;
        }

        if (document.activeElement && document.activeElement !== document.body) {
          $this.previousActiveElement = document.activeElement;
        } else {
          $this.previousActiveElement = null;
        }

        if (popup.getAttribute("data-body-scroll-disable") === "true") {
          const isMobile =
            typeof window !== "undefined" &&
            window.matchMedia &&
            window.matchMedia("(max-width: 749px)").matches;

          if (isMobile) {
            document.body.classList.add("popup-scroll-hidden-mobile");
            document.body.classList.remove("popup-scroll-hidden");
          } else {
            document.body.classList.add("popup-scroll-hidden");
            document.body.classList.remove("popup-scroll-hidden-mobile");
          }
        }

        const limit =
          (parseInt($this.getStorage("popup-" + popup.dataset.id)) || 0) + 1;
        $this.setStorage("popup-" + popup.dataset.id, limit, {
          expires: popup.dataset.limitLifetime,
        });

        popup.classList.add("popup-open");
        $this.currentPopup = popup;
        popup.dataset.initScrollPx = window.scrollY;
        popup.dataset.initScrollPercent = $this.getScrollPercent();

        $this.applyAnimation(popup, popup.dataset.openAnimation);
        $this.closeTriggerPopup(popup);

        const focusable = $this.getFocusableElements(popup);
        const autofocusEl =
          focusable.find((el) => el.hasAttribute("autofocus")) || null;

        const focusWithoutScroll = function (el) {
          if (!el || typeof el.focus !== "function") return;
          try {
            el.focus({ preventScroll: true });
          } catch (e) {
            el.focus();
          }
        };

        if (autofocusEl) {
          focusWithoutScroll(autofocusEl);
        } else if (focusable.length > 0) {
          focusWithoutScroll(focusable[0]);
        } else if (typeof popup.focus === "function") {
          focusWithoutScroll(popup);
        }

        popup
          .querySelectorAll(
            '[tabindex="-1"].newsletter-form__message--success'
          )
          .forEach((el) => {
            if (typeof el.focus === "function") {
              try {
                el.focus({ preventScroll: true });
              } catch (e) {
                el.focus();
              }
            }
          });
      },

      closePopup: function (el) {
        const popup = el.closest(".popup");
        if (!popup) return;

        const animation = popup.dataset.exitAnimation;
        $this.applyAnimation(popup, animation, function () {
          popup.classList.add("popup-already-opened");
          popup.classList.remove("popup-open");

          const hasLockedPopup = document.querySelector(
            '.popup-open[data-body-scroll-disable="true"]'
          );

          if (!hasLockedPopup) {
            document.body.classList.remove("popup-scroll-hidden");
            document.body.classList.remove("popup-scroll-hidden-mobile");
          }

          if ($this.currentPopup === popup) {
            const nextOpenPopup = document.querySelector(".popup-open");
            $this.currentPopup = nextOpenPopup || null;
          }

          if (!$this.currentPopup && $this.previousActiveElement) {
            try {
              $this.previousActiveElement.focus();
            } catch (e) {
              // element might have been removed; ignore
            }
            $this.previousActiveElement = null;
          }
        });
      },

      agePopup: function (el) {
        const popup = el.closest(".popup");
        const isEditor =
          typeof window !== "undefined" &&
          window.Shopify &&
          window.Shopify.designMode;

        if (!isEditor) {
          $this.setStorage("popup-age-" + popup.dataset.id, 1, {
            expires: 360,
          });
        }
      },

      ageDeclined: function () {
        document
          .querySelector(".age-verification__question")
          ?.classList.remove("show");
        document
          .querySelector(".age-verification__declined")
          ?.classList.add("show");
      },

      acceptPopup: function (el) {
        const popup = el.closest(".popup");
        $this.setStorage("popup-accept-" + popup.dataset.id, 1, {
          expires: 360,
        });
      },

      applyAnimation: function (popup, name, callback) {
        const overlay = popup.nextElementSibling?.classList.contains(
          "popup-overlay"
        )
          ? popup.nextElementSibling
          : null;

        const overlayName =
          typeof callback === "function" ? "popupExitFade" : "popupOpenFade";

        if (overlay) {
          overlay.classList.add("popup-animated", overlayName);
          overlay.addEventListener("animationend", function handler() {
            overlay.classList.remove("popup-animated", overlayName);
            overlay.removeEventListener("animationend", handler);
          });
        }

        const wrap = popup.querySelector(".popup-wrap");
        if (wrap) {
          wrap.classList.add("popup-animated", name);
          wrap.addEventListener("animationend", function handler() {
            wrap.classList.remove("popup-animated", name);
            wrap.removeEventListener("animationend", handler);
            if (typeof callback === "function") callback();
          });
        }
      },

      getStorage: function (key) {
        const item = localStorage.getItem(key);
        if (!item) return undefined;
        try {
          const parsed = JSON.parse(item);
          if (parsed.expires && Date.now() > parsed.expires) {
            localStorage.removeItem(key);
            return undefined;
          }
          return parsed.value;
        } catch {
          return undefined;
        }
      },

      setStorage: function (key, value, options = {}) {
        const data = { value, expires: null };
        if (options.expires) {
          const expiresDate = new Date();
          expiresDate.setDate(
            expiresDate.getDate() + parseInt(options.expires, 10)
          );
          data.expires = expiresDate.getTime();
        }
        localStorage.setItem(key, JSON.stringify(data));
      },

      getScrollPercent: function () {
        const h = document.documentElement;
        const b = document.body;
        return (
          ((h.scrollTop || b.scrollTop) /
            ((h.scrollHeight || b.scrollHeight) - h.clientHeight)) *
          100
        );
      },

      isAllowPopup: function (popup) {
        const limitDisplay = parseInt(popup.dataset.limitDisplay || 0);
        const limitDisplayCookie = parseInt(
          $this.getStorage("popup-" + popup.dataset.id)
        );
        if (
          limitDisplay &&
          limitDisplayCookie &&
          limitDisplayCookie >= limitDisplay
        ) {
          return false;
        }
        return true;
      },

      getFocusableElements: function (popup) {
        const selectors = [
          'a[href]:not([tabindex="-1"])',
          'button:not([disabled]):not([tabindex="-1"])',
          'input:not([disabled]):not([tabindex="-1"])',
          'select:not([disabled]):not([tabindex="-1"])',
          'textarea:not([disabled]):not([tabindex="-1"])',
          '[tabindex]:not([tabindex="-1"])',
        ].join(",");

        if (!popup) return [];

        const elements = Array.prototype.slice.call(
          popup.querySelectorAll(selectors)
        );

        return elements.filter(function (el) {
          const style = window.getComputedStyle(el);
          return style.visibility !== "hidden" && style.display !== "none";
        });
      },
    };
  })();

  adpPopup.init();

  document.addEventListener("shopify:section:load", function () {
    adpPopup.init();
  });

  document.addEventListener("shopify:section:unload", function () {
    document.body.classList.remove("popup-scroll-hidden");
    document.body.classList.remove("popup-scroll-hidden-mobile");
  });
});
